import { type TGenre as TApiGenre } from '@core/api'

import { type TGenre } from '@core/models'

export const convertGenre = (apiGenre: TApiGenre): TGenre => {
    const {
        slug,
        subgenres,
        tag,
        title,
        description,
        image,
        generated_image,
        audio_count,
        parent_title,
        date_updated,
    } = apiGenre

    return {
        slug,
        tag,
        title,
        description,
        image,
        generatedImage: generated_image,
        dateUpdated: date_updated,
        audioCount: audio_count,
        subgenres: subgenres?.map(convertGenre),
        parentTitle: parent_title,
    }
}
